import { useEffect, useState } from "react";
import axios from "axios";

import "../css/adminFooter.css";

import AdminSidebar from "../components/AdminSidebar";

import API_URL from "../config/config";


function AdminFooter() {


    const [footer, setFooter] = useState({

        id: "",

        company_name: "",

        address: "",

        phone: "",

        email: "",

        facebook: "",

        instagram: "",

        twitter: "",

        youtube: "",

        copyright: ""

    });



    useEffect(() => {

        loadFooter();

    }, []);





    // GET FOOTER DATA

    const loadFooter = async () => {

        try {


            const res = await axios.get(

                `${API_URL}/footer`

            );


            if(res.data){

                setFooter(res.data);

            }


        }

        catch(err){

            console.log(
                "Footer Load Error",
                err
            );

        }

    };







    // INPUT CHANGE

    const changeHandler = (e) => {


        setFooter({

            ...footer,

            [e.target.name]: e.target.value

        });


    };








    // ADD / UPDATE FOOTER

    const saveFooter = async () => {


        const token = localStorage.getItem("token");



        try {



            if(footer.id){


                await axios.put(

                    `${API_URL}/admin/footer/${footer.id}`,

                    footer,

                    {

                        headers:{

                            Authorization:
                            `Bearer ${token}`

                        }

                    }

                );


                alert(
                    "Footer Updated Successfully"
                );



            }

            else {



                await axios.post(

                    `${API_URL}/admin/footer`,

                    footer,

                    {

                        headers:{

                            Authorization:
                            `Bearer ${token}`

                        }

                    }

                );


                alert(
                    "Footer Added Successfully"
                );


            }



            loadFooter();



        }

        catch(err){


            console.log(err);


            alert(
                "Footer Save Failed"
            );


        }


    };









    // DELETE FOOTER

    const deleteFooter = async () => {


        const token = localStorage.getItem("token");



        try{


            await axios.delete(

                `${API_URL}/admin/footer/${footer.id}`,

                {

                    headers:{

                        Authorization:
                        `Bearer ${token}`

                    }

                }

            );



            alert(
                "Footer Deleted Successfully"
            );



            setFooter({

                id:"",
                company_name:"",
                address:"",
                phone:"",
                email:"",
                facebook:"",
                instagram:"",
                twitter:"",
                youtube:"",
                copyright:""

            });



        }

        catch(err){


            console.log(err);


            alert(
                "Delete Failed"
            );


        }


    };









    return (


        <div className="admin-layout">



            <AdminSidebar />




            <div className="admin-content">



                <div className="admin-footer">



                    <h1>
                        Footer Management
                    </h1>





                    <label>
                        Company Name
                    </label>


                    <input

                        type="text"

                        name="company_name"

                        value={footer.company_name}

                        onChange={changeHandler}

                    />





                    <label>
                        Address
                    </label>


                    <textarea

                        name="address"

                        value={footer.address}

                        onChange={changeHandler}

                    />







                    <label>
                        Phone
                    </label>


                    <input

                        type="text"

                        name="phone"

                        value={footer.phone}

                        onChange={changeHandler}

                    />








                    <label>
                        Email
                    </label>


                    <input

                        type="email"

                        name="email"

                        value={footer.email}

                        onChange={changeHandler}

                    />








                    <label>
                        Facebook
                    </label>


                    <input

                        type="text"

                        name="facebook"

                        value={footer.facebook}

                        onChange={changeHandler}

                    />








                    <label>
                        Instagram
                    </label>


                    <input

                        type="text"

                        name="instagram"

                        value={footer.instagram}

                        onChange={changeHandler}

                    />








                    <label>
                        Twitter
                    </label>


                    <input

                        type="text"

                        name="twitter"

                        value={footer.twitter}

                        onChange={changeHandler}

                    />








                    <label>
                        YouTube
                    </label>


                    <input

                        type="text"

                        name="youtube"

                        value={footer.youtube}

                        onChange={changeHandler}

                    />








                    <label>
                        Copyright
                    </label>


                    <textarea

                        name="copyright"

                        value={footer.copyright}

                        onChange={changeHandler}

                    />







                    <button

                        onClick={saveFooter}

                    >

                        Save Footer

                    </button>







                    {

                    footer.id &&


                    <button

                        className="delete-btn"

                        onClick={deleteFooter}

                    >

                        Delete Footer

                    </button>


                    }





                </div>



            </div>



        </div>


    );


}



export default AdminFooter;